import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { VehicleVersionMenuItem } from "../model/VehicleVersionMenuItem";

@Injectable({
  providedIn: "root",
})
export class VehicleVersionReportService {
  constructor(private readonly http: HttpClient) {}

  getVehicleVersionReportData(
    filters: VehicleVersionMenuItem,
    pageSize: number,
    pageNum: number
  ): Observable<any> {
    const url =
      environment.serviceURL +
      `/vehicleVersionReportData?pageSize=${pageSize}&pageNum=${pageNum}`;
    return this.http.post<any>(url, filters);
  }

  getNumberOfVehicleRecords(filters: VehicleVersionMenuItem): Observable<any> {
    const url = environment.serviceURL + "/numVehRecords";
    return this.http.post<any>(url, filters);
  }

  getVehicleVersionMenuItems(): Observable<any> {
    const url = environment.serviceURL + "/VehicleVersionMenuItems";
    return this.http.get<any>(url);
  }

  getVehicleVersionTieredMenuItems(vehicleId: number): Observable<any> {
    const url =
      environment.serviceURL + `/vehicleVersionRecord?vehicleId=${vehicleId}`;
    return this.http.get<any>(url);
  }
}
